import {SuspendedTile, Tile} from "../components/Tile.tsx";
import {BundleCapsule} from "../bundle/capsule.tsx";
import {BundleActor, BundleSceneTileContent} from "../bundle/timeline.tsx";
import {Joyable} from "../components/joyx.tsx";
import {bundleStatusCodeColor, bundleStatusCodeLabelKeys} from "../bundle/status.tsx";
import {useScheduledTransferForBundle} from "../rpc/webrpc-client.gen.ts";
import {useTranslation} from "react-i18next";
import {VenueCapsule} from "../venue/capsule.tsx";
import {faTruckClock} from "@fortawesome/pro-regular-svg-icons";
import {spawnTstzSpan} from "../tstzspan.ts";
import {SceneTileContent} from "./DispatchTile.tsx";
import {RouterJoyLink} from "../link.tsx";
import {TruckCapsule} from "../truck/capsule.tsx";

// interface DispatchBundleSceneProps {
//     bundleId: string;
//     color: SheetProps["color"];
//     variant: SheetProps["variant"];
// }
//
// function DispatchBundleScene({bundleId, color: inColor, variant: inVariant}: DispatchBundleSceneProps) {
//     const {t} = useTranslation();
//
//     const {data: bundleData} = useQuery(watchBundleByIdTqo({bundleId}));
//     const bundle = bundleData?.bundle;
//     const {data: bundleStatus} = useBundleStatus({bundleId});
//     // TODO: watching all of these sounds needlessly heavy on subscription management
//     const {data: lastTransferData, isSuccess: isLastTransferSuccess}
//         = useQuery(watchLastTransferForBundleTqo({bundleId}));
//     const lastTransfer = lastTransferData?.transfer;
//     const {data: scheduledTransferData, isSuccess: isScheduledTransferSuccess}
//         = useQuery(watchScheduledTransferForBundleTqo({bundleId}));
//     const scheduledTransfer = scheduledTransferData?.scheduledTransfer;
//     const truckId = scheduledTransfer?.truck?.id ?? lastTransfer?.truck?.id ?? TQDEADBEEF;
//     const {data: triplegData, isSuccess: isTriplegSuccess} = useQuery({
//         ...watchLastTriplegForTruckTqo({truckId}),
//         enabled: truckId !== TQDEADBEEF
//     });
//     const tripleg = triplegData?.tripleg;
//
//     if (!bundle || !bundleStatus || !isLastTransferSuccess ||
//         !isScheduledTransferSuccess || !isTriplegSuccess) {
//         return null
//     }
//
//     const isAtDestination = !!bundle.destination?.id &&
//         bundle.destination.id === bundleStatus.place?.venue?.id;
//     const scheduledActionWhen = scheduledTransfer?.arrivalWindow ?? UNKNOWN_WHEN;
//
//     if (!isAtDestination && !scheduledTransfer) {
//         // we are orphaned
//         return <DispatchScene color="danger" variant="solid" icon={faCalendarExclamation}
//                               what={t("bundleStatus.orphaned")} when={scheduledActionWhen}
//                               where={<PlaceCapsule place={bundleStatus.place}/>}/>
//     }
//
//     if (!!scheduledTransfer && !scheduledTransfer.truck) {
//         return <DispatchScene color="danger" variant="soft" icon={faPersonCircleQuestion}
//                               what={t("bundleStatus.scheduledTruckUnknown")} when={scheduledActionWhen}
//                               where={<PlaceCapsule place={bundleStatus.place}/>}/>
//     }
//
//     if (!!scheduledTransfer && !scheduledTransfer.driver) {
//         return <DispatchScene color="danger" variant="soft" icon={faPersonCircleQuestion}
//                               what={t("bundleStatus.scheduledDriverUnknown")} when={scheduledActionWhen}
//                               where={<PlaceCapsule place={bundleStatus.place}/>}/>
//     }
//
//     if (scheduledTransfer) {
//         if (tripleg) {
//             if (tripleg.destination.id === scheduledTransfer.venue.id) {
//                 if (tripleg.admitted ?? tripleg.arrived) {
//                     return <DispatchScene color="success" variant={inVariant} what={t("driver.arrived")}
//                                           icon={faTruckFront}
//                                           when={tripleg.admitted ?? tripleg.arrived!}/>
//                 }
//             }
//         }
//     }
//
//     return <Box>dispatch bundle panic bundle id {bundleId}</Box>;
// }

// function useDispatchBundleColor({dxb}: { dxb: Touchable<DispatchBundle> }): SheetProps["color"] {
//     const mama = useMothership();
//     const bundle = dxb.value.bundle;
//     const bundleId = bundle.id;
//     const {data: bundleStatus} = useBundleStatus({bundleId});
//     // TODO: watching all of these sounds needlessly heavy on subscription management
//     const {data: lastTransferData, isSuccess: isLastTransferSuccess}
//         = useQuery(watchLastTransferForBundleTqo(mama, {bundleId}));
//     const lastTransfer = lastTransferData?.transfer;
//     const {data: scheduledTransferData, isSuccess: isScheduledTransferSuccess}
//         = useQuery(watchScheduledTransferForBundleTqo(mama, {bundleId}));
//     const scheduledTransfer = scheduledTransferData?.scheduledTransfer;
//     // const truckId = scheduledTransfer?.truck?.id ?? lastTransfer?.truck?.id ?? TQDEADBEEF;
//     // const {data: triplegData, isSuccess: isTriplegSuccess} = useQuery({
//     //     ...watchLastTriplegForTruckTqo({truckId}),
//     //     enabled: truckId !== TQDEADBEEF
//     // });
//     // const tripleg = triplegData?.tripleg;
//
//     if (!bundleStatus || !isLastTransferSuccess || !isScheduledTransferSuccess
// //        || !isTriplegSuccess
//     ) {
//         return "neutral";
//     }
//
//     const isAtDestination = !!bundle.destination?.id &&
//         bundle.destination.id === bundleStatus.place?.venue?.id;
//
//     if (!isAtDestination && !scheduledTransfer) {
//         // we are orphaned
//         return "danger";
//     }
//
//     if (scheduledTransfer) {
//         return "tertiary";
//     }
//
//     if (lastTransfer) {
//         if ((!!lastTransfer.onloadStarted && !lastTransfer.onloadEnded) ||
//             (!!lastTransfer.offloadStarted && !lastTransfer.offloadEnded)) {
//             return "primary";
//         }
//         if (!!lastTransfer.onloadEnded && !lastTransfer.offloadStarted) {
//             return "success";
//         }
//     }
//
//     return "neutral";
// }

export interface DispatchBundleTileProps extends Joyable {
    dxb: BundleActor;
    isStarred?: boolean;
}

export function DispatchBundleTile({dxb, color: inColor, ...rest}: DispatchBundleTileProps) {
    const bundle = dxb.bundle;
    const {t} = useTranslation();
    //const bundleId = bundle.id;
    const scene = dxb.lastScene;
    const scheduledPickupTqrv = useScheduledTransferForBundle({bundleId: dxb.bundle.id});
    const color = inColor ?? bundleStatusCodeColor[dxb.status.code];

    if (scheduledPickupTqrv.isPending) {
        return <SuspendedTile/>
    }

    let content = scene
        ? <BundleSceneTileContent scene={scene} color={color} {...rest}/>
        : undefined;

    if (!content && !!scheduledPickupTqrv.data) {
        const where = bundle.origin.venue
            ? <VenueCapsule venue={bundle.origin.venue}/>
            : undefined;
        const when = scheduledPickupTqrv.data.arrivalWindow
            ? {span: spawnTstzSpan(scheduledPickupTqrv.data.arrivalWindow)}
            : {at: scheduledPickupTqrv.data.posted};

        content = <SceneTileContent color={color}
                                    when={when}
                                    what={t(bundleStatusCodeLabelKeys.AWAITING_PICKUP)}
                                    where={where}
                                    icon={{icon: faTruckClock}}>
            {scheduledPickupTqrv.data.truck?.id
                ? <RouterJoyLink to="/truck/$id/timeline" params={{id: scheduledPickupTqrv.data.truck.id}}
                                 color={color}>
                    <TruckCapsule truck={scheduledPickupTqrv.data.truck}/>
            </RouterJoyLink>
                : null}
        </SceneTileContent>
    }

    return <Tile key={bundle.id} variant="outlined" color={color}
                 Subject={(props) =>
                     <BundleCapsule bundle={bundle} {...props}/>}>
        {content}
    </Tile>
}

// export function DispatchBundleTile(props: DispatchBundleTileProps) {
//     const dxb = props.dxb;
//     //const mama = useMothership();
//     const {t} = useTranslation();
//     const bundle = dxb.bundle;
//     const bundleId = bundle.id;
//     const bundleStatus = dxb.status;
//     const lastUpdated = bundleActorLastModified(dxb);
//     const joyDecos = useDecoDecay({
//         scenes: DECO_DELAY_SCENES,
//         lastUpdated,
//     });
//     const variant = joyDecos.variant;
//
//     const lastTransferTqrv = useLastTransferForBundle({bundleId});
//     const lastTransfer = lastTransferTqrv.data;
//     const currentVenue = lastTransfer?.offloadEnded
//         ? lastTransfer.offloadVenue : bundle.origin.venue;
//
//     const loadedTruckStub = !!lastTransfer && !lastTransfer.offloadEnded
//         ? lastTransfer.truck : undefined;
//     //const loadedTruckId = loadedTruckStub?.id ?? TQDEADBEEF;
//     const loadedTriplegTqrv
//         = useLastTriplegForTruck(loadedTruckStub ? {truckId: loadedTruckStub.id} : undefined);
//     const loadedTripleg =
//         loadedTriplegTqrv.data?.destination.id === bundle.destination?.id
//             ? loadedTriplegTqrv.data : undefined;
//     // const {data: loadedTriplegContentData} = useTriplegContent({
//     //     tripleg: loadedTripleg!,
//     //     pov: {bundle: bundleId},
//     //     enabled: !!loadedTripleg,
//     // });
//     // const loadedTriplegColor = loadedTriplegContentData?.color;
//     // const loadedTriplegContent = loadedTriplegContentData?.content;
//
//     const scheduledTransferTqrv
//         = useScheduledTransferForBundle({bundleId});
//     const scheduledTransfer = scheduledTransferTqrv.data;
//     const scheduledTruckStub = scheduledTransfer
//         ? scheduledTransfer.truck : undefined;
//     // const scheduledTruckId = scheduledTruckStub?.id ?? TQDEADBEEF;
//     // const scheduledTriplegTqrv
//     //     = useLastTriplegForTruck(scheduledTruckStub ? {truckId: scheduledTruckStub.id} : undefined);
//     // const scheduledTripleg = scheduledTriplegTqrv.data;
//     // const inboundTripleg = scheduledTripleg?.destination.id === currentVenue?.id
//     //     ? scheduledTripleg : undefined;
//     // const {data: inboundTriplegContent} = useTriplegContent({
//     //     tripleg: inboundTripleg,
//     //     pov: {bundle: bundleId},
//     //     enabled: !!inboundTripleg,
//     // });
//
//     const truckId = lastTransfer?.truck.id ?? scheduledTruckStub?.id;
//     const {data: crewPresences} = useTruckCrewPresences(truckId ? {truckId} : undefined);
//     const crewCapsules = (crewPresences ?? []).map(presence =>
//         <AgentPresenceCapsule presence={presence} key={presence.agent.id} icon={{icon: faSteeringWheel}}/>);
//     const isOnDuty = isAnybodyOnDuty(crewPresences);
//
//     let color: SheetProps["color"] | undefined;
//     if (!isOnDuty) {
//         color = "warning";
//     }
//     const content: ReactNode[] = [];
//
//     switch (bundleStatus.code) {
//         case undefined:
//         case BundleStatusCode.enum.UNKNOWN:
//             content.push(<FontAwesomeIcon size="2x" icon={faQuestion} key="loneIcon"/>);
//             break;
//
//         case BundleStatusCode.enum.INACTIVE:
//             content.push(<FontAwesomeIcon size="2x" icon={faFishBones} key="loneIcon"/>);
//             break;
//
//         case BundleStatusCode.enum.AWAITING_PICKUP: {
//             if (inboundTriplegContent) {
//                 color = color ?? inboundTriplegContent.color;
//                 absorb(content, inboundTriplegContent.content);
//                 // if (!inboundTripleg.arrived && !inboundTripleg.admitted) {
//                 //     color = "success";
//                 //     content.push(<DispatchScene key="scene"
//                 //                                 icon={{icon: faTruckFast}} color={color} variant={variant}
//                 //                                 what={t("driver.departed")}
//                 //                                 where={inboundTripleg.origin
//                 //                                     ? <VenueCapsule venue={inboundTripleg.origin}/>
//                 //                                     : null}
//                 //                                 when={formatDispatchTimestamp(inboundTripleg.departed)}/>,
//                 //         ...crewCapsules);
//                 // } else if (inboundTripleg.arrived && !inboundTripleg.admitted) {
//                 //     color = "warning";
//                 //     content.push(<DispatchScene key="scene"
//                 //                                 when={formatDispatchTimestamp(inboundTripleg.arrived)}
//                 //                                 what={t("driver.arrived")}
//                 //                                 where={<VenueCapsule venue={inboundTripleg.destination}/>}
//                 //                                 icon={{icon: faHourglassStart}} color={color} variant={variant}/>,
//                 //         ...crewCapsules);
//                 // } else if (inboundTripleg.admitted) {
//                 //     color = "primary";
//                 //     content.push(<DispatchScene key="scene"
//                 //                                 when={formatDispatchTimestamp(inboundTripleg.admitted)}
//                 //                                 what={t("driver.arrived")}
//                 //                                 where={<VenueCapsule venue={inboundTripleg.destination}/>}
//                 //                                 icon={{icon: faTruckFront}} color={color} variant={variant}/>,
//                 //         ...crewCapsules);
//                 // }
//             } else {
//                 let sceneIcon: FontAwesomeIconProps = {icon: faBomb};
//                 let sceneWhen: string = UNKNOWN_WHEN;
//                 let sceneWhat: string = TQDEADBEEF;
//                 if (!bundleStatus.place?.venue) {
//                     throw new Error("cannot be waiting for pickup in nowhere");
//                 }
//                 const sceneWhere = <VenueCapsule venue={bundleStatus.place.venue}/>;
//                 color = "tertiary";
//
//                 if (scheduledTransfer) {
//                     if (!scheduledTransfer.truck) {
//                         color = "danger";
//                         sceneIcon = {icon: faPersonCircleQuestion};
//                         sceneWhat = t("bundleStatus.scheduledTruckUnknown");
//                     } else if (!scheduledTransfer.driver) {
//                         color = "danger";
//                         sceneIcon = {icon: faPersonCircleQuestion};
//                         sceneWhat = t("bundleStatus.scheduledDriverUnknown");
//                     } else if (scheduledTransfer.arrivalWindow) {
//                         sceneIcon = {icon: faCalendarClock};
//                         const awtzspan = new TstzSpan(scheduledTransfer.arrivalWindow);
//                         sceneWhen = awtzspan.asTimeIntervalString() ?? UNKNOWN_WHEN;
//                         sceneWhat = t("bundleStatus.pickupScheduled");
//                     } else {
//                         color = "warning";
//                         sceneIcon = {icon: faCalendarClock};
//                         sceneWhat = t("bundleStatus.pickupScheduled");
//                     }
//                 } else {
//                     color = "danger";
//                     sceneIcon = {icon: faExclamationTriangle};
//                     sceneWhat = t("bundleStatus.orphaned");
//                 }
//                 content.push(<SceneTileContent key="scene"
//                                                color={color} icon={sceneIcon} variant={variant}
//                                                what={sceneWhat} when={sceneWhen} where={sceneWhere}/>);
//             }
//         }
//             break;
//
//         case BundleStatusCode.ONLOADING:
//             if (!lastTransfer?.onloadStarted) {
//                 throw new Error("need onload started here");
//             }
//             if (!lastTransfer.onloadVenue) {
//                 throw new Error("need onload venue here");
//             }
//             color = color ?? "primary";
//             content.push(<SceneTileContent key="scene"
//                                            color={color} icon={{icon: faTruckRampBox}} variant={variant}
//                                            what={t("bundleStatus.onloading")}
//                                            when={formatTileTimestamp(lastTransfer.onloadStarted)}
//                                            where={<VenueCapsule venue={lastTransfer.onloadVenue}/>}/>,
//                 <TruckCapsule key="truck" truck={lastTransfer.truck}/>, crewCapsules);
//             break;
//
//         case BundleStatusCode.ONLOADED:
//             if (!lastTransfer?.onloadEnded) {
//                 throw new Error("need onload ended here");
//             }
//             if (!lastTransfer.onloadVenue) {
//                 throw new Error("need onload venue here");
//             }
//             color = "warning";
//             content.push(<SceneTileContent key="scene" color={color} icon={{icon: faTruckContainer}}
//                                            variant={variant}
//                                            what={t("bundleStatus.onloaded")}
//                                            when={formatTileTimestamp(lastTransfer.onloadEnded)}
//                                            where={<VenueCapsule venue={lastTransfer.onloadVenue}/>}/>,
//                 <TruckCapsule key="truck" truck={lastTransfer.truck}/>, crewCapsules);
//             break;
//
//         case BundleStatusCode.FIELD_APPROVED:
//             if (loadedTripleg) {
//                 color = color ?? loadedTriplegColor;
//                 absorb(content, loadedTriplegContent);
//             } else {
//                 if (!lastTransfer?.onloadEnded) {
//                     throw new Error("need onload ended here");
//                 }
//                 if (!lastTransfer.onloadVenue) {
//                     throw new Error("need onload venue here");
//                 }
//                 color = color ?? "success";
//                 content.push(<SceneTileContent key="scene" color={color} icon={{icon: faClipboardCheck}}
//                                                variant={variant}
//                                                what={t("fieldApproved")}
//                                                when={formatTileTimestamp(lastTransfer.onloadEnded)}
//                                                where={<VenueCapsule venue={lastTransfer.onloadVenue}/>}/>,
//                     <TruckCapsule key="truck" truck={lastTransfer.truck}/>, crewCapsules);
//             }
//             break;
//
//         case BundleStatusCode.OFFLOADING:
//             if (!lastTransfer?.offloadStarted) {
//                 throw new Error("need offload started here");
//             }
//             if (!lastTransfer.offloadVenue) {
//                 throw new Error("need offload venue here");
//             }
//             color = color ?? "primary";
//             content.push(<SceneTileContent key="scene" color={color}
//                                            icon={{icon: faRampLoading, flip: "horizontal"}}
//                                            variant={variant}
//                                            what={t("driver.offloading")}
//                                            when={formatTileTimestamp(lastTransfer.offloadStarted)}
//                                            where={<VenueCapsule venue={lastTransfer.offloadVenue}/>}/>,
//                 <TruckCapsule key="truck" truck={lastTransfer.truck}/>, crewCapsules);
//             break;
//
//         case BundleStatusCode.DELIVERED:
//             if (!lastTransfer?.offloadEnded) {
//                 throw new Error("need offload ended here");
//             }
//             if (!lastTransfer.offloadVenue) {
//                 throw new Error("need offload venue here");
//             }
//             color = "success";
//             content.push(<SceneTileContent key="scene" color={color} icon={{icon: faFlagCheckered}}
//                                            variant={variant}
//                                            what={t("delivered")}
//                                            when={formatTileTimestamp(lastTransfer.offloadEnded)}
//                                            where={<VenueCapsule venue={lastTransfer.offloadVenue}/>}
//             />)
//     }
//
//     // const pickupId = scheduledTransfer?.id ?? TQDEADBEEF;
//     // const {data: scheduledPickupData} = useScheduledPickupTileContent({
//     //     pickupId, showTruck: true, showDriver: true, enabled: pickupId !== TQDEADBEEF
//     // });
//     // let color = scheduledPickupData?.color ?? "neutral";
//     //
//     // const truckId = scheduledTransfer?.truck?.id ?? TQDEADBEEF;
//     // const {data: inboundTriplegData} = useQuery({
//     //     ...watchLastTriplegForTruckTqo(mama, {truckId}), enabled: truckId !== TQDEADBEEF
//     // });
//     // const inboundTriplegId = inboundTripleg?.id ?? TQDEADBEEF;
//     // const {data: inboundTriplegScene} = useTriplegContent({
//     //     triplegId: inboundTriplegId, enabled: inboundTriplegId !== TQDEADBEEF
//     // });
//     // if (inboundTriplegScene?.color) {
//     //     color = inboundTriplegScene.color;
//     // }
//
//     if (!bundleStatus
//         || !isLastTransferSuccess
//         || !isScheduledTransferSuccess
//         //    || !isTriplegSuccess
//     ) {
//         return <SuspendedTile color={color} variant="outlined"/>;
//     }
//
//     // const marquee = <EntityCapsule entity={bundle} color={color} variant={childVariant}/>
//
//     return <Tile key={bundle.id} variant="outlined" color={color}
//                  Subject={(props) =>
//                      <BundleCapsule bundle={bundle} {...props}/>}>
//         {content}
//
//         {/*{inboundTriplegScene*/}
//         {/*    ? <>{inboundTriplegScene.content}*/}
//         {/*        <TruckCapsule truck={inboundTripleg!.truck} linkify={true}/>*/}
//         {/*    </>*/}
//         {/*    : (scheduledTransfer && scheduledPickupData?.content*/}
//         {/*        ? scheduledPickupData.content*/}
//         {/*        : null)}*/}
//         {/*    } else {*/}
//         {/*        const isAtDestination = !!bundle.destination?.id &&*/}
//         {/*        bundle.destination.id === bundleStatus.place?.venue?.id;*/}
//
//         {/*        const sceneProps: DispatchSceneProps = {*/}
//         {/*        color,*/}
//         {/*        variant: childVariant,*/}
//         {/*        icon: {icon: faBomb},*/}
//         {/*        when: UNKNOWN_WHEN,*/}
//         {/*        what: TQDEADBEEF,*/}
//         {/*        where: <PlaceCapsule place={bundleStatus.place}/>,*/}
//         {/*};*/}
//
//         {/*    if (!isAtDestination) {*/}
//         {/*        // we are orphaned*/}
//         {/*        sceneProps.color = "danger";*/}
//         {/*        sceneProps.variant = "solid";*/}
//         {/*        sceneProps.icon = {icon: faCalendarExclamation};*/}
//         {/*        sceneProps.what = t("bundleStatus.orphaned");*/}
//         {/*    }*/}
//         {/*}*/}
//         <Sheet color={color} variant={variant}>
//             <HCBox>{t("dispatch.asof", {
//                 when: formatTileTimestamp(lastUpdated)
//             })}</HCBox>
//         </Sheet>
//     </Tile>
// }


//                    switch (bundleStatus.code
// )
//     {

//     case
//         BundleStatusCode.UNKNOWN
//     :
//         return <DispatchScene when="?" what={t("statusUnknown")}
//                               icon={faQuestion} color={color} variant={variant}/>
//     case
//         BundleStatusCode.AWAITING_PICKUP
//     :
//         return <DispatchScene when={scheduledTransfer!.posted}
//                               what={t("bundleStatus.awaitingPickup")}
//                               icon={faHourglass} color={color} variant={variant}/>
//     case
//         BundleStatusCode.ONLOADING
//     :
//         break;
//     case
//         BundleStatusCode.ONLOADED
//     :
//         break;
//     case
//         BundleStatusCode.FIELD_APPROVED
//     :
//         break;
//     case
//         BundleStatusCode.DELIVERED
//     :
//         break;
//     case
//         BundleStatusCode.OFFLOADING
//     :
//         break;
//     case
//         BundleStatusCode.INACTIVE
//     :
//         break;
//     }
//
//
//     if (!tripleg.arrived && !tripleg.admitted) {
//         return <DispatchScene icon={faTruckFast} color={color} variant={variant}
//                               what={t("driver.departed")}
//                               where={tripleg.origin
//                                   ?
//                                   <VenueCapsule venue={tripleg.origin} color={color} variant={variant}/>
//                                   : null}
//                               when={tripleg.departed}/>
//     } else if (tripleg.arrived && !tripleg.admitted) {
//         return <DispatchScene
//             when={tripleg.arrived} what={t("driver.arrived")}
//             where={<VenueCapsule venue={tripleg.destination} color={color} variant={variant}/>}
//             icon={faHourglassStart} color={color} variant={variant}/>
//     } else if (tripleg.admitted) {
//         let statusIcon: IconDefinition;
//         if (!openTransfers || openTransfers.length == 0) {
//             statusIcon = faTruckContainerEmpty;
//         } else {
//             const activeOffload = openTransfers.find(maybe =>
//                 !!maybe.offloadStarted && !maybe.offloadEnded);
//             const activeOnload = openTransfers.find(maybe =>
//                 !!maybe.onloadStarted && !maybe.onloadEnded);
//             if (activeOffload ?? activeOnload) {
//                 statusIcon = faTruckRampBox;
//             } else {
//                 statusIcon = faTruckContainer;
//             }
//         }
//         return <DispatchScene when={tripleg.admitted} what={t("driver.admitted")}
//                               where={<VenueCapsule venue={tripleg.destination}
//                                                    color={color} variant={variant}/>}
//                               icon={statusIcon} color={color} variant={variant}/>;
//     } else {
//         return null;
//     }
// }
